<template>
  <v-navigation-drawer
    id="core-navigation-drawer"
    v-model="drawer"
    :mini-variant.sync="$vuetify.breakpoint.smAndDown ? null : drawer"
    mini-variant-width="60"
    mobile-breakpoint="960"
    :permanent="!$vuetify.breakpoint.smAndDown"
    :temporary="$vuetify.breakpoint.smAndDown"
    :width="$vuetify.breakpoint.smAndDown ? '100%' : 300"
    app
    v-bind="$attrs"
  >
    <!-- :class="drawer ? 'drawer-close' : 'drawer-open'" -->
    <!-- :right="$vuetify.rtl" -->
    <v-divider class="mb-1" />
    <v-list
      dense
      nav
    >
      <v-list-item class="brand-logo">
        <v-list-item-avatar
          class="align-self-center company-logo"
          color="dark"
          tile
          contain
        >
          <v-img
            v-if="user.isAdmin || user.user_type == 'orko'"
            class="orko-admin"
            src="@/assets/brandLogo/logo.png"
          />
          <v-img
            v-else
            :src="user.business_logo"
          />
        </v-list-item-avatar>
        <div class="content">
          <div class="title">
            {{ profile.title }}
          </div>
          <div
            v-if="profile.subTitle"
            class="subTitle"
          >
            {{ profile.subTitle }}
          </div>
        </div>

        <!-- <v-list-item-content>
          <v-list-item-title class="display-1">
            {{ profile.title }}
          </v-list-item-title>
        </v-list-item-content> -->
      </v-list-item>
    </v-list>

    <!-- v-if="isMini" -->
    <div class="nav-search-wrap px-3 pb-2">
      <v-text-field
        v-model="navSearch"
        dense
        solo
        flat
        hide-details
        clearable
        placeholder="Search menu..."
        prepend-inner-icon="mdi-magnify"
        background-color="rgba(255,255,255,0.08)"
        class="nav-search"
      />
    </div>

    <v-divider class="mb-2 mx-3" />

    <v-list
      expand
      nav
    >
      <!-- Style cascading bug  -->
      <!-- https://github.com/vuetifyjs/vuetify/pull/8574 -->
      <div />

      <template v-for="(item, i) in searchedItems">
        <v-list-group
          v-if="item.children.length > 0"
          :key="i"
          :value="navSearch ? true : i == 0"
        >
          <!-- :prepend-icon="item.icon" -->
          <template v-slot:activator>
            <v-list-item-icon>
              <v-icon v-if="item.icon">
                {{ item.icon }}
              </v-icon>
              <Icons
                v-else
                :name="item.myIcon"
              />
            </v-list-item-icon>
            <!-- Tooltip for main items -->
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-list-item-title
                  v-bind="attrs"
                  v-on="on"
                >
                  {{ item.title }}
                </v-list-item-title>
              </template>
              <span>{{ item.title }}</span>
            </v-tooltip>
          </template>

          <template v-for="(row, j) in item.children">
            <v-list-group
              v-if="row.children && row.children.length > 0"
              :key="'g' + j"
              :value="navSearch ? true : false"
            >
              <template v-slot:activator>
                <v-list-item-icon>
                  <v-icon v-if="row.icon">
                    {{ row.icon }}
                  </v-icon>
                  <Icons
                    v-else
                    :name="row.myIcon"
                    size="sm"
                  />
                </v-list-item-icon>

                <!-- Tooltip for nested group items -->
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-list-item-title
                      v-bind="attrs"
                      v-on="on"
                    >
                      {{ row.title }}
                    </v-list-item-title>
                  </template>
                  <span>{{ row.title }}</span>
                </v-tooltip>
              </template>

              <v-list-item
                v-for="(sub, k) in row.children"
                :key="k"
                :to="changeRoute(sub, sub.name)"
                :class="checkActivePath(sub.name)"
              >
                <v-list-item-icon>
                  <v-icon v-if="sub.icon">
                    {{ sub.icon }}
                  </v-icon>
                  <Icons
                    v-else
                    :name="sub.myIcon"
                    size="sm"
                  />
                </v-list-item-icon>

                <!-- Tooltip for sub-nested items -->
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-list-item-title
                      v-bind="attrs"
                      v-on="on"
                    >
                      {{ sub.title }}
                    </v-list-item-title>
                  </template>
                  <span>{{ sub.title }}</span>
                </v-tooltip>
              </v-list-item>
            </v-list-group>

            <v-list-item
              v-else-if="row.to"
              :key="'i' + j"
              :to="changeRoute(row, row.name)"
              :class="checkActivePath(row.name)"
            >
              <!-- @click="changeRoute(row, row.name)" -->
              <v-list-item-icon>
                <v-icon v-if="row.icon">
                  {{ row.icon }}
                </v-icon>
                <Icons
                  v-else
                  :name="row.myIcon"
                  size="sm"
                />
              </v-list-item-icon>

              <!-- Tooltip for nested items -->
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-list-item-title
                    v-bind="attrs"
                    v-on="on"
                  >
                    {{ row.title }}
                  </v-list-item-title>
                </template>
                <span>{{ row.title }}</span>
              </v-tooltip>
            </v-list-item>
          </template>
        </v-list-group>
        <template v-else-if="item.to">
          <v-list-item
            v-if="item?.meta?.click"
            :key="'uu' + i"
            :href="changingMetaRoute(item)"
            :class="checkActivePath(item.name)"
            target="_blank"
          >
            <v-list-item-icon>
              <!-- <v-icon>{{ item.icon }}</v-icon> -->
              <v-icon v-if="item.icon">
                {{ item.icon }}
              </v-icon>
              <Icons
                v-else
                :name="item.myIcon"
              />
            </v-list-item-icon>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-list-item-title
                  v-bind="attrs"
                  v-on="on"
                >
                  {{ item.title }}
                </v-list-item-title>
              </template>
              <span>{{ item.title }}</span>
            </v-tooltip>
          </v-list-item>
          <v-list-item
            v-else
            :key="'u' + i"
            :to="changeRoute(item, item.name)"
            :class="checkActivePath(item.name)"
          >
            <!-- @click="changeRoute(item, item.name)" -->
            <v-list-item-icon>
              <!-- <v-icon>{{ item.icon }}</v-icon> -->
              <v-icon v-if="item.icon">
                {{ item.icon }}
              </v-icon>
              <Icons
                v-else
                :name="item.myIcon"
              />
            </v-list-item-icon>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-list-item-title
                  v-bind="attrs"
                  v-on="on"
                >
                  {{ item.title }}
                </v-list-item-title>
              </template>
              <span>{{ item.title }}</span>
            </v-tooltip>
          </v-list-item>
        </template>

        <!-- <base-item-group
          v-if="item.children"
          :key="`group-${i}`"
          :item="item"
        >
        </base-item-group>

        <base-item
          v-else
          :key="`item-${i}`"
          :item="item"
        /> -->
      </template>

      <!-- Style cascading bug  -->
      <!-- https://github.com/vuetifyjs/vuetify/pull/8574 -->
      <div />
    </v-list>

    <v-divider class="mb-2 mx-3" />

    <!-- <template v-slot:append>
      <v-list
        expand
        nav
      >
        <v-list-item @click="logout()">
          <v-list-item-icon>
            <v-icon v-text="`mdi-power-standby`" />
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title v-text="$t('logout')" />
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </template> -->
  </v-navigation-drawer>
</template>

<script>
/* eslint-disable */
// Utilities
import { mapState, mapGetters } from "vuex";

export default {
  name: "DashboardCoreDrawer",
  components: { Icons: () => import("../../components/base/icons.vue") },
  props: {
    expandOnHover: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      mini: true,
      navSearch: "",
      items: [
        // Dashboard
        // {
        //   icon: "mdi-view-dashboard",
        //   title: "dashboard",
        //   name: "dashboard",
        //   to: "/",
        //   children: [],
        // },

        //
        ...(this.$admin.hasAccessTo("dashboard.list")
          ? [
              {
                icon: "mdi-view-dashboard",
                title: "dashboard",
                name: "dashboard",
                to: "/",
                children: [],
              },
            ]
          : []),
        // Dashboard

        // ORKO AI Insights

        ...(this.$admin.hasAccessTo("dashboard.list")
          ? [
              {
                myIcon: "orko-ai",
                title: "AI_insights",
                name: "AI_insights",
                to: "/ORKO-AI-Insights",
                children: [],
              },
            ]
          : []),

        // ORKO AI Insights

        // live map

        ...(this.$admin.hasAccessTo("live-tracking.list")
          ? [
              {
                icon: "mdi-map-clock",
                title: "live_tracking",
                name: "live_tracking",
                to: "/live-tracking",
                children: [],
              },
            ]
          : []),
        // live map

        // GeoFence

        ...(this.$admin.hasAccessTo("live-tracking.list")
          ? [
              {
                icon: "mdi-map-marker-radius",
                title: "geofence",
                name: "geofence",
                to: "/geofence",
                children: [],
              },
            ]
          : []),
        // GeoFence

        // Vehicle Telematic
        {
          myIcon: "electric-bike",
          title: "telematics",
          name: "telematics",
          group: "telematics",
          expanded: true,
          children: [
            ...(this.$admin.hasAccessTo("vehicle-telematics.list")
              ? [
                  {
                    myIcon: "telematics",
                    title: "vehicle_telematics",
                    name: "vehicle_telematics",
                    to: "/vehicle-telematics",
                  },
                ]
              : []),
            ...(this.$admin.hasAccessTo("vehicle-trips.list")
              ? [
                  {
                    icon: "mdi-road-variant",
                    title: "trips",
                    name: "trips",
                    to: "/trips",
                  },
                ]
              : []),

            ...(this.$admin.hasAccessTo("vehicle-charge-sessions.list")
              ? [
                  {
                    icon: "mdi-ev-station",
                    title: "charge_session",
                    name: "charge_session",
                    to: "/charge-session",
                  },
                ]
              : []),
            ...(this.$admin.hasAccessTo("battery-diagnostics.list")
              ? [
                  {
                    icon: "mdi-battery-sync",
                    title: "battery_diagnostics",
                    name: "battery_diagnostics",
                    to: "/battery-diagnostics",
                  },
                ]
              : []),
            ...(this.$admin.hasAccessTo("vehicles.remote")
              ? [
                  {
                    icon: "mdi-remote",
                    title: "remote_on_off",
                    name: "remote_on_off",
                    to: "/vehicle-activity",
                  },
                ]
              : []),
            ...(this.$admin.hasAccessTo("vehicle-telematics.list")
              ? [
                  {
                    icon: "mdi-view-dashboard",
                    title: "arrival_dashboard",
                    name: "arrival_dashboard",
                    to: "/arrival-dashboard",
                  },
                ]
              : []),
          ],
        },
        // Vehicle Telematic

        //  Battery analytics

        ...(this.$admin.hasAccessTo("battery-analytics.view")
          ? [
              {
                // myIcon: "orko-ai",
                icon: "mdi-battery-charging-80",
                title: "battery_analytics",
                name: "battery_analytics",
                to: "/battery-analytics",
                meta: { click: true },
                children: [],
              },
            ]
          : []),

        //  Battery analytics

        // Maintenance
        {
          icon: "mdi-cogs",
          title: "maintenance",
          name: "maintenance",
          group: "maintenance",
          expanded: false,
          children: [
            ...(this.$admin.hasAccessTo("vehicle-maintenance-logs.list")
              ? [
                  {
                    icon: "mdi-wrench-cog",
                    title: "vehicle_maintenance_logs",
                    name: "vehicle_maintenance_logs",
                    to: "/vehicle-maintenance-logs",
                  },
                ]
              : []),

            ...(this.$admin.hasAccessTo("upcoming-vehicle-maintenance.list")
              ? [
                  {
                    icon: "mdi-cog-transfer",
                    title: "upcoming_vehicle_maintenance",
                    name: "upcoming_vehicle_maintenance",
                    to: "/upcoming-vehicle-maintenance",
                  },
                ]
              : []),
            ...(this.$admin.hasAccessTo("service-log.list")
              ? [
                  {
                    icon: "mdi-wrench-cog",
                    title: "vehicle_services_logs",
                    name: "vehicle_services_logs",
                    to: "/vehicle-services-logs",
                  },
                ]
              : []),
          ],
        },
        // Maintenance
        // Inventory Management
        {
          icon: "mdi-car-cog",
          title: "inventory_management",
          name: "inventory_management",
          group: "inventory_management",
          expanded: false,
          children: [
            ...(this.$admin.hasAccessTo("categories.list")
              ? [
                  {
                    icon: "mdi-ballot",
                    title: "category",
                    name: "category",
                    to: "/category",
                  },
                ]
              : []),
            ...(this.$admin.hasAccessTo("parts.list")
              ? [
                  {
                    icon: "mdi-bolt",
                    title: "parts",
                    name: "parts",
                    to: "/parts",
                  },
                ]
              : []),
            ...(this.$admin.hasAccessTo("inventory.list")
              ? [
                  {
                    icon: "mdi-car-cog",
                    title: "inventory",
                    name: "inventory",
                    to: "/inventory",
                  },
                ]
              : []),
          ],
        },
        // Inventory Management

        // Performance Management
        {
          icon: "mdi-speedometer",
          title: "performance",
          name: "performance",
          group: "performance",
          expanded: false,
          children: [
            ...(this.$admin.hasAccessTo("vehicle-comparision.list")
              ? [
                  {
                    // icon: "mdi-call-split",
                    myIcon: "bike-comparison1",
                    title: "vehicle_comparison",
                    name: "vehicle_comparison",
                    to: "/vehicle-comparison",
                  },
                ]
              : []),
            ...(this.$admin.hasAccessTo("driver-comparision.list")
              ? [
                  {
                    // icon: "mdi-call-split",
                    myIcon: "driver-comparison",
                    title: "driver_comparison",
                    name: "driver_comparison",
                    to: "/driver-comparison",
                  },
                ]
              : []),
          ],
        },
        // Performance Managment

        // Route Optimizied
        {
          icon: "mdi-google-maps",
          title: "routes",
          name: "routes",
          group: "routes",
          expanded: true,
          children: [
            ...(this.$admin.hasAccessTo("route-planning.list")
              ? [
                  {
                    icon: "mdi-map-marker-distance",
                    title: "route_planning",
                    name: "route_planning",
                    to: "/route-planning",
                    children: [],
                  },
                ]
              : []),
            ...(this.$admin.hasAccessTo("route-tracking.list")
              ? [
                  {
                    icon: "mdi-map",
                    title: "routes",
                    name: "routes",
                    to: "/routes",
                    children: [],
                  },
                ]
              : []),
            ...(this.$admin.hasAccessTo("routes.list")
              ? [
                  {
                    icon: "mdi-map",
                    title: "route_listing",
                    name: "route_listing",
                    to: "/route-listing",
                    children: [],
                  },
                ]
              : []),

            ...(this.$admin.hasAccessTo("routes.comparision")
              ? [
                  {
                    icon: "mdi-map-marker-multiple",
                    title: "route_comparison",
                    name: "route_comparison",
                    to: "/route-comparison",
                    children: [],
                  },
                ]
              : []),
            ...(this.$admin.hasAccessTo("route.list")
              ? [
                  {
                    icon: "mdi-map-marker-radius",
                    title: "route-optimization",
                    name: "route-optimization",
                    to: "/route-optimization",
                    children: [],
                  },
                ]
              : []),
          ],
        },
        // Route Optimizied

        //  EV Rental
        ...(this.$admin.hasAccessTo("ev-rental.view")
          ? [
              {
                // myIcon: "orko-ai",
                icon: "mdi-car-key",
                title: "ev_rental",
                name: "ev_rental",
                to: "/ev-rental",
                meta: { click: true },
                children: [],
              },
            ]
          : []),
        //  EV Rental

        //  Delivery

        ...(this.$admin.hasAccessTo("delivery.view")
          ? [
              {
                // myIcon: "orko-ai",
                icon: "mdi-truck-delivery",
                title: "delivery",
                name: "delivery",
                to: "/delivery",
                meta: { click: true },
                children: [],
              },
            ]
          : []),

        //  Delivery

        // Charging Management
        {
          icon: "mdi-lightning-bolt",
          title: "charging-management",
          name: "charging-management",
          group: "charging-management",
          expanded: false,
          children: [
            ...(this.$admin.hasAccessTo("charging-dashboard.list")
              ? [
                  {
                    icon: "mdi-view-dashboard",
                    title: "charging_dashboard",
                    name: "charging_dashboard",
                    to: "/charging-dashboard",
                  },
                  {
                    icon: "mdi-view-dashboard",
                    title: "charging_dashboard_v1",
                    name: "charging_dashboard_v1",
                    to: "/charging-dashboard-v1",
                  },
                ]
              : []),

            // Operations
            {
              icon: "mdi-sine-wave",
              title: "operations",
              name: "operations",
              group: "operations",
              expanded: false,
              children: [
                ...(this.$admin.hasAccessTo("charging-dashboard.list")
                  ? [
                      {
                        icon: "mdi-ev-station",
                        title: "charger_location",
                        name: "charger_location",
                        to: "/charger-location",
                      },
                    ]
                  : []),

                ...(this.$admin.hasAccessTo("charger-maintenance.list")
                  ? [
                      {
                        icon: "mdi-ev-plug-ccs2",
                        title: "charger_maintenance",
                        name: "charger_maintenance",
                        to: "/charger-maintenance",
                      },
                    ]
                  : []),
                ...(this.$admin.hasAccessTo(
                  "ticket-management-and-reports.list"
                )
                  ? [
                      {
                        icon: "mdi-ticket-confirmation",
                        title: "ticket_management_and_reports",
                        name: "ticket_management_and_reports",
                        to: "/ticket-management-and-reports",
                      },
                    ]
                  : []),
                ...(this.$admin.hasAccessTo("charging-sessions.list")
                  ? [
                      {
                        icon: "mdi-ev-station",
                        title: "charging_sessions",
                        name: "charging_sessions",
                        to: "/charging-sessions",
                      },
                    ]
                  : []),
                ...(this.$admin.hasAccessTo("bookings.list")
                  ? [
                      {
                        icon: "mdi-book-check",
                        title: "bookings",
                        name: "bookings",
                        to: "/bookings",
                      },
                    ]
                  : []),
                ...(this.$admin.hasAccessTo("bookings-operator")
                  ? [
                      {
                        icon: "mdi-account-tag",
                        title: "bookings_operator",
                        name: "bookings_operator",
                        to: "/bookings-operator",
                      },
                    ]
                  : []),
                ...(this.$admin.hasAccessTo("availability-dashboard.list")
                  ? [
                      {
                        icon: "mdi-wrench-clock",
                        title: "availability_dashboard",
                        name: "availability_dashboard",
                        to: "/availability-dashboard",
                      },
                    ]
                  : []),
                ...(this.$admin.hasAccessTo("downtime.list")
                  ? [
                      {
                        icon: "mdi-sort-clock-ascending",
                        title: "downtime_list",
                        name: "downtime_list",
                        to: "/downtime-list",
                      },
                    ]
                  : []),
                ...(this.$admin.hasAccessTo("severity-and-escalation.list")
                  ? [
                      {
                        icon: "mdi-invoice-text-clock",
                        title: "severity_and_escalation",
                        name: "severity_and_escalation",
                        to: "/severity-and-escalation",
                      },
                    ]
                  : []),
              ],
            },
            // Operations
            // Assets and Devices
            {
              icon: "mdi-power-plug",
              title: "assets_and_devices",
              name: "assets_and_devices",
              group: "assets_and_devices",
              expanded: false,
              children: [
                ...(this.$admin.hasAccessTo("charging-connectors.list")
                  ? [
                      {
                        icon: "mdi-ev-station",
                        title: "charge_connectors",
                        name: "charge_connectors",
                        to: "/charge-connectors",
                      },
                    ]
                  : []),
                ...(this.$admin.hasAccessTo("operations-troubleshooting.list")
                  ? [
                      {
                        icon: "mdi-stethoscope",
                        title: "charger_diagnostics",
                        name: "charger_diagnostics",
                        to: "/charger-diagnostics",
                      },
                    ]
                  : []),
                ...(this.$admin.hasAccessTo("firmware.list")
                  ? [
                      // {
                      //   icon: "mdi-database-search",
                      //   title: "diagnostics",
                      //   name: "diagnostics",
                      //   to: "/diagnostics",
                      // },
                      {
                        icon: "mdi-chip",
                        title: "firmware",
                        name: "firmware",
                        to: "/firmware",
                      },
                    ]
                  : []),
                ...(this.$admin.hasAccessTo("ocpp-logs.list")
                  ? [
                      {
                        icon: "mdi-file-document",
                        title: "ocpp_logs",
                        name: "ocpp_logs",
                        to: "/ocpp-logs",
                      },
                    ]
                  : []),
                ...(this.$admin.hasAccessTo("rfid.list")
                  ? [
                      {
                        icon: "mdi-qrcode-scan",
                        title: "rfid",
                        name: "rfid",
                        to: "/rfid",
                      },
                    ]
                  : []),
                ...(this.$admin.hasAccessTo("generate-qr-code.list")
                  ? [
                      {
                        icon: "mdi-qrcode-scan",
                        title: "generate_qr_code",
                        name: "generate_qr_code",
                        to: "/generate-qr-code",
                      },
                    ]
                  : []),
                ...(this.$admin.hasAccessTo("config-management.list")
                  ? [
                      {
                        icon: "mdi-tune-vertical",
                        title: "config_management",
                        name: "config_management",
                        to: "/config-management",
                      },
                    ]
                  : []),
              ],
            },
            // Assets and Devices

            // Analytics and Insights
            {
              icon: "mdi-chart-areaspline",
              title: "analytics_and_insights",
              name: "analytics_and_insights",
              group: "analytics_and_insights",
              expanded: false,
              children: [
                ...(this.$admin.hasAccessTo(
                  "energy-analyzer-and-efficiency.list"
                )
                  ? [
                      {
                        icon: "mdi-google-analytics",
                        title: "energy_analyzer_and_efficiency",
                        name: "energy_analyzer_and_efficiency",
                        to: "/energy-analyzer-and-efficiency",
                      },
                    ]
                  : []),
                ...(this.$admin.hasAccessTo("utilization.list")
                  ? [
                      {
                        icon: "mdi-speedometer",
                        title: "utilization",
                        name: "utilization",
                        to: "utilization",
                      },
                    ]
                  : []),
                ...(this.$admin.hasAccessTo("users-analytics-dashboard")
                  ? [
                      {
                        icon: "mdi-account-details",
                        title: "users_analytics_dashboard",
                        name: "users_analytics_dashboard",
                        to: "/users-analytics-dashboard",
                      },
                    ]
                  : []),
                ...(this.$admin.hasAccessTo("sla-dashboard.list")
                  ? [
                      {
                        icon: "mdi-clipboard-check-outline",
                        title: "sla_dashboard",
                        name: "sla_dashboard",
                        to: "/sla-dashboard",
                      },
                    ]
                  : []),
                ...(this.$admin.hasAccessTo("data-completeness.list")
                  ? [
                      {
                        icon: "mdi-database",
                        title: "data_completeness",
                        name: "data_completeness",
                        to: "/data-completeness",
                      },
                    ]
                  : []),
              ],
            },
            // Analytics and Insights

            // Finance and Billing
            {
              icon: "mdi-finance",
              title: "finance_and_billing",
              name: "finance_and_billing",
              group: "finance_and_billing",
              expanded: false,
              children: [
                ...(this.$admin.hasAccessTo("billing-and-invoices.list")
                  ? [
                      {
                        icon: "mdi-currency-usd",
                        title: "billing_and_invoices",
                        name: "billing_and_invoices",
                        to: "/billing-and-invoices",
                      },
                    ]
                  : []),
                ...(this.$admin.hasAccessTo("financials.list")
                  ? [
                      {
                        icon: "mdi-finance",
                        title: "financials",
                        name: "financials",
                        to: "/financials",
                      },
                    ]
                  : []),
                ...(this.$admin.hasAccessTo("revenue-share.list")
                  ? [
                      {
                        icon: "mdi-arrow-decision",
                        title: "revenue_share",
                        name: "revenue_share",
                        to: "/revenue-share",
                      },
                    ]
                  : []),
              ],
            },
            // Finance and Billing

            // System
            {
              icon: "mdi-cog",
              title: "system",
              name: "system",
              group: "system",
              expanded: false,
              children: [
                ...(this.$admin.hasAccessTo(
                  "energy-analyzer-and-efficiency.list"
                )
                  ? [
                      {
                        icon: "mdi-google-analytics",
                        title: "energy_analyzer",
                        name: "energy_analyzer",
                        to: "/energy-analyzer",
                      },
                    ]
                  : []),
                ...(this.$admin.hasAccessTo("revenue-sharing.list")
                  ? [
                      {
                        icon: "mdi-arrow-decision",
                        title: "revenue_sharing",
                        name: "revenue_sharing",
                        to: "/revenue-sharing",
                      },
                    ]
                  : []),
                ...(this.$admin.hasAccessTo("audit-logs.list")
                  ? [
                      {
                        icon: "mdi-history",
                        title: "user_audit_logs",
                        name: "user_audit_logs",
                        to: "/user-audit-logs",
                      },
                    ]
                  : []),
              ],
            },
            // System
          ],
        },
        // Charging Management
        //Fuel Management
        {
          icon: "mdi-fuel",
          title: "fuel-management",
          name: "fuel-management",
          group: "fuel-management",
          expanded: false,
          children: [
            ...(this.$admin.hasAccessTo("vehicle-fuel-dashboard.list")
              ? [
                  {
                    icon: "mdi-view-dashboard",
                    title: "vehicle_fuel_dashboard",
                    name: "vehicle_fuel_dashboard",
                    to: "/vehicle-fuel-dashboard",
                  },
                ]
              : []),
            ...(this.$admin.hasAccessTo("fuel-dispenser-dashboard.list")
              ? [
                  {
                    icon: "mdi-gas-station",
                    title: "fuel_dispenser_dashboard",
                    name: "fuel_dispenser_dashboard",
                    to: "/fuel-dispenser-dashboard",
                  },
                ]
              : []),
            ...(this.$admin.hasAccessTo("terminals.list")
              ? [
                  {
                    icon: "mdi-railroad-light",
                    title: "terminal",
                    name: "terminal",
                    to: "/terminal",
                  },
                ]
              : []),
            ...(this.$admin.hasAccessTo("fuel-tanks.list")
              ? [
                  {
                    icon: "mdi-fuel-cell",
                    title: "fuel_tank",
                    name: "fuel_tank",
                    to: "/fuel-tank",
                  },
                ]
              : []),
            ...(this.$admin.hasAccessTo("fuel-prices.list")
              ? [
                  {
                    icon: "mdi-fuel",
                    title: "fuel_prices",
                    name: "fuel_prices",
                    to: "/fuel-prices",
                  },
                ]
              : []),
            ...(this.$admin.hasAccessTo("vehicle-fuel-sessions.list")
              ? [
                  {
                    icon: "mdi-tanker-truck",
                    title: "vehicle_fuel_sessions",
                    name: "vehicle_fuel_sessions",
                    to: "/vehicle-fuel-sessions",
                  },
                ]
              : []),
            ...(this.$admin.hasAccessTo("dispensers.list")
              ? [
                  {
                    icon: "mdi-barrel",
                    title: "dispensers",
                    name: "dispensers",
                    to: "/dispensers",
                  },
                ]
              : []),
            ...(this.$admin.hasAccessTo("dispensers.list")
              ? [
                  {
                    icon: "mdi-file-excel",
                    title: "data_logs",
                    name: "data_logs",
                    to: "/data-logs",
                  },
                ]
              : []),
            ...(this.$admin.hasAccessTo("dispensers.list")
              ? [
                  {
                    icon: "mdi-file-compare",
                    title: "logs_comparison",
                    name: "logs_comparison",
                    to: "/logs-comparison",
                  },
                ]
              : []),
          ],
        },
        //Fuel Management
        // Reports
        {
          icon: "mdi-file-chart",
          title: "reports",
          name: "reports",
          group: "reports",
          expanded: false,
          children: [
            ...(this.$admin.hasAccessTo("journey-reports.list")
              ? [
                  {
                    icon: "mdi-transit-connection-variant",
                    title: "transit_reports",
                    name: "transit_reports",
                    to: "/transit-reports",
                  },
                ]
              : []),
            ...(this.$admin.hasAccessTo("journey-reports.list")
              ? [
                  {
                    icon: "mdi-file-certificate",
                    title: "compliance_reports",
                    name: "compliance_reports",
                    to: "/compliance-reports",
                  },
                ]
              : []),
            ...(this.$admin.hasAccessTo("journey-reports.list")
              ? [
                  {
                    icon: "mdi-poll",
                    title: "journey_reports",
                    name: "journey_reports",
                    to: "/journey-reports",
                  },
                ]
              : []),
            ...(this.$admin.hasAccessTo("daily-mileage-reports.list")
              ? [
                  {
                    icon: "mdi-flag-triangle",
                    title: "daily_mileage_reports",
                    name: "daily_mileage_reports",
                    to: "/daily-mileage-reports",
                  },
                ]
              : []),
          ],
        },
        // Reports
        // Flespi Management
        {
          icon: "mdi-hub",
          title: "middleware_configuration",
          name: "flespi",
          group: "flespi",
          expanded: false,
          children: [
            ...(this.$admin.hasAccessTo("flespi-streams.list")
              ? [
                  {
                    icon: "mdi-call-split",
                    title: "streams",
                    name: "streams",
                    to: "/streams",
                  },
                ]
              : []),

            ...(this.$admin.hasAccessTo("flespi-plugins.list")
              ? [
                  {
                    icon: "mdi-power-plug",
                    title: "plugins",
                    name: "plugins",
                    to: "/plugins",
                  },
                ]
              : []),

            ...(this.$admin.hasAccessTo("flespi-calcs.list")
              ? [
                  {
                    icon: "mdi-calculator",
                    title: "calculators",
                    name: "calculators",
                    to: "/calculators",
                  },
                ]
              : []),
          ],
        },
        // Flespi Management

        // Alerts and Notifications
        {
          icon: "mdi-bell-cog",
          title: "alerts_&_notifications",
          name: "alerts_&_notifications",
          group: "alerts_&_notifications",
          expanded: false,
          children: [
            ...(this.$admin.hasAccessTo("alerts.list")
              ? [
                  {
                    icon: "mdi-bell-alert",
                    title: "alerts",
                    name: "alerts",
                    to: "/alerts",
                  },
                ]
              : []),
            {
              icon: "mdi-bell-badge",
              title: "notifications",
              name: "notifications",
              to: "/notifications",
            },

            // ...(this.$admin.hasAccessTo("alerts.list")
            //   ? [
            //       {
            //         icon: "mdi-bell-badge",
            //         title: "notifications",
            //         name: "notifications",
            //         to: "/notifications",
            //       },
            //     ]
            //   : []),
          ],
        },
        // Alerts and Notifications

        // Fleet Dashboard
        ...(this.$admin.hasAccessTo("live-tracking.list")
          ? [
              {
                icon: "mdi-view-dashboard",
                title: "fleet_transition_dashboard",
                name: "fleet_transition_dashboard",
                to: "/fleet-transition-dashboard",
                children: [],
              },
            ]
          : []),
        // Fleet Dashboard

        // Setup
        {
          myIcon: "setting",
          title: "setup",
          name: "setup",
          group: "setup",
          expanded: false,
          children: [
            ...(this.$admin.hasAccessTo("roles.list")
              ? [
                  {
                    icon: "mdi-account-lock",
                    title: "roles",
                    name: "roles",
                    to: "/roles",
                  },
                ]
              : []),
            ...(this.$admin.hasAccessTo("roles.list")
              ? [
                  {
                    icon: "mdi-account-lock",
                    title: "product_tiers",
                    name: "product_tiers",
                    to: "/proudct-tiers",
                  },
                ]
              : []),
            ...(this.$admin.hasAccessTo("cso-client.list")
              ? [
                  {
                    icon: "mdi-account",
                    title: "cso_clients",
                    name: "cso_clients",
                    to: "/cso-clients",
                  },
                ]
              : []),
            ...(this.$admin.hasAccessTo("users.list")
              ? [
                  {
                    icon: "mdi-account",
                    title: "users",
                    name: "users",
                    to: "/users",
                  },
                ]
              : []),

            ...(this.$admin.hasAccessTo("tenants.list")
              ? [
                  {
                    icon: "mdi-table-cog",
                    title: "tenants_management",
                    name: "tenants_management",
                    to: "/tenants-management",
                  },
                ]
              : []),
            ...(this.$admin.hasAccessTo("tenant-configurations.list")
              ? [
                  {
                    icon: "mdi-table-cog",
                    title: "tenant_configurations",
                    name: "tenant_configurations",
                    to: "/tenant-configurations",
                  },
                ]
              : []),
            ...(this.$admin.hasAccessTo("tenant-configurations.list")
              ? [
                  {
                    icon: "mdi-table-cog",
                    title: "tenant_relationship",
                    name: "tenant_relationship",
                    to: "/tenant-relationship",
                  },
                ]
              : []),
            ...(this.$admin.hasAccessTo("tenant-chargers-assignment.list")
              ? [
                  {
                    icon: "mdi-table-cog",
                    title: "tenant_chargers_assignment",
                    name: "tenant_chargers_assignment",
                    to: "/tenant-chargers-assignment",
                  },
                ]
              : []),
            ...(this.$admin.hasAccessTo("tenant-configurations.list")
              ? [
                  {
                    icon: "mdi-table-cog",
                    title: "vehicle_assign",
                    name: "vehicle_assign",
                    to: "/vehicle-assign",
                  },
                ]
              : []),
            // ...(this.$admin.hasAccessTo("oem-clients.list")
            //   ? [
            //       {
            //         icon: "mdi-table-cog",
            //         title: "oem-clients.index",
            //         name: "oem-clients.index",
            //         to: "/oem-clients/index",
            //       },
            //     ]
            //   : []),
            ...(this.$admin.hasAccessTo("data-sims.list")
              ? [
                  {
                    icon: "mdi-sim",
                    title: "data_sims",
                    name: "data_sims",
                    to: "/data-sims",
                  },
                ]
              : []),

            ...(this.$admin.hasAccessTo("iot-device-models.list")
              ? [
                  {
                    icon: "mdi-devices",
                    title: "iot_device_providers",
                    name: "iot_device_providers",
                    to: "/iot-device-models",
                  },
                ]
              : []),

            ...(this.$admin.hasAccessTo("iot-devices.list")
              ? [
                  {
                    icon: "mdi-tablet-cellphone",
                    title: "iot_devices",
                    name: "iot_devices",
                    to: "/iot-devices",
                  },
                ]
              : []),
            ...(this.$admin.hasAccessTo("md-makes.list")
              ? [
                  {
                    // icon: "mdi-table-cog",
                    myIcon: "ev_make",
                    title: "md_makes",
                    name: "md_makes",
                    to: "/md-makes",
                  },
                ]
              : []),
            ...(this.$admin.hasAccessTo("md-models.list")
              ? [
                  {
                    // icon: "mdi-table-cog",
                    myIcon: "ev_model",
                    title: "md_models",
                    name: "md_models",
                    to: "/md-models",
                  },
                ]
              : []),
            ...(this.$admin.hasAccessTo("vehicles.list")
              ? [
                  {
                    icon: "mdi-atv",
                    title: "vehicles",
                    name: "vehicles",
                    to: "/vehicles",
                  },
                ]
              : []),
            ...(this.$admin.hasAccessTo("vehicle-groups.list")
              ? [
                  {
                    myIcon: "groups",
                    title: "groups",
                    name: "groups",
                    to: "/groups",
                  },
                ]
              : []),
            ...(this.$admin.hasAccessTo("locations.list")
              ? [
                  {
                    icon: "mdi-map-marker",
                    title: "locations",
                    name: "locations",
                    to: "/locations",
                  },
                ]
              : []),
            ...(this.$admin.hasAccessTo("rates.list")
              ? [
                  {
                    icon: "mdi-finance",
                    title: "rates",
                    name: "rates",
                    to: "/rates",
                  },
                ]
              : []),
            ...(this.$admin.hasAccessTo("charge-stations.list")
              ? [
                  {
                    icon: "mdi-ev-station",
                    title: "charge_stations",
                    name: "charge_stations",
                    to: "/charge-stations",
                  },
                ]
              : []),
            ...(this.$admin.hasAccessTo("charge-stations-assignment.list")
              ? [
                  {
                    icon: "mdi-ev-station",
                    title: "charge_stations_assignment",
                    name: "charge_stations_assignment",
                    to: "/charge-stations-assignment",
                  },
                ]
              : []),
            ...(this.$admin.hasAccessTo("staff-assignment.list")
              ? [
                  {
                    myIcon: "customer",
                    title: "staff_assignment",
                    name: "staff_assignment",
                    to: "/staff_assignment",
                  },
                ]
              : []),
            ...(this.$admin.hasAccessTo("driving-staff.list")
              ? [
                  {
                    myIcon: "customer",
                    title: "driving_staff",
                    name: "driving_staff",
                    to: "/driving-staff",
                  },
                ]
              : []),
            ...(this.$admin.hasAccessTo("oem-customers.list")
              ? [
                  {
                    myIcon: "customer",
                    title: "oem_customers",
                    name: "oem_customers",
                    to: "/oem-customers",
                  },
                ]
              : []),
            ...(this.$admin.hasAccessTo("oem-b2b.list")
              ? [
                  {
                    icon: "mdi-office-building",
                    title: "oem_business",
                    name: "oem_business",
                    to: "/oem-business",
                  },
                ]
              : []),

            ...(this.$admin.hasAccessTo("batteries.list")
              ? [
                  {
                    icon: "mdi-battery-charging",
                    title: "batterries",
                    name: "batterries",
                    to: "/batteries",
                  },
                ]
              : []),
          ],
        },
        // Setup
        // Order Management
        ...(this.$admin.hasAccessTo("order-management.list")
          ? [
              {
                icon: "mdi-flag-triangle",
                title: "order_management",
                name: "order_management",
                to: "/order-management",
                children: [],
              },
            ]
          : []),
        // Order Management

        // Help and Support
        ...(this.$admin.hasAccessTo("help-support.list")
          ? [
              {
                icon: "mdi-face-agent",
                title: "support_tickets",
                name: "support_tickets",
                to: "/support-tickets",
                children: [],
              },
            ]
          : []),

        // {
        //   icon: "mdi-view-dashboard",
        //   title: "dashboard",
        //   name: "dashboard",
        //   to: "/",
        // },

        // ...(this.$admin.hasAny(["oem-clients.list"])
        //   ? [
        //       {
        //         icon: "mdi-table-cog",
        //         title: "oem-management",
        //         name: "oem-clients",
        //         group: "oem-clients",
        //         expanded: true,
        //         children: [

        //         ],
        //       },
        //     ]
        //   : []),

        // ...(this.$admin.hasAccessTo("help-support.list")
        //   ? [
        //       {
        //         icon: "mdi-ticket-account",
        //         title: "support-tickets",
        //         name: "csupport-tickets",
        //         to: "/support-tickets",
        //       },
        //     ]
        //   : []),
      ],
    };
  },

  computed: {
    ...mapState(["barColor", "barImage"]),
    ...mapGetters({
      authUser: "getUser",
    }),
    activePath() {
      return this.$route.name;
    },
    drawer: {
      get() {
        return this.$store.state.drawer;
      },
      set(val) {
        this.$store.commit("SET_DRAWER", val);
      },
    },
    computedItems() {
      return this.items.map(this.mapItem);
    },
    profile() {
      return {
        avatar: true,
        title: this.$t("avatar"),
        subTitle: this.$t("sub-avatar"),
      };
    },
    user() {
      return this.$store.getters.getUser;
    },
    // computedFilteredItems() {
    //   const userRole = this.user.role[0];
    //   const userNature = this.user.user_nature;
    //   return this.computedItems.map((item) => {
    //     if (userRole == "OMS Role" || userNature == "cso") {

    //       let filteredChildren = item.children?.filter(
    //         (child) => child.name !== 'notifications' && child.name !== 'alerts'
    //       );
    //       if (userNature == "cso") {
    //         filteredChildren = filteredChildren?.filter((child) => child.name !== "dashboard");
    //       }
    //       return { ...item, children: filteredChildren || [] };
    //     }
    //     else if (userRole != "Super-Admin" && userNature != "cso") {
    //       const filteredChildren = item.children?.filter(
    //         (child) => child.name !== 'charging_sessions'
    //       );
    //       return { ...item, children: filteredChildren || [] };
    //     }
    //     return item;
    //   });
    // },
    isMini() {
      return !this.$vuetify.breakpoint.smAndDown && !this.drawer;
    },
    searchedItems() {
      const q = (this.navSearch || "").toLowerCase().trim();
      if (!q) return this.computedFilteredItems;
      return this.computedFilteredItems
        .map((item) => this.filterItemByQuery(item, q))
        .filter(Boolean);
    },
    computedFilteredItems() {
      const userRole = this.user.role[0];
      const userNature = this.user.user_nature;

      return this.computedItems
        .filter((item) => {
          // Remove 'dashboard' at the top-level if userNature is 'cso'
          if (userNature === "cso" && item.name === "dashboard") {
            return false; // Exclude this item
          }
          return true; // Keep other items
        })
        .map((item) => {
          if (userRole === "OMS Role" || userNature === "cso") {
            // Filter out children nodes (if applicable)
            const filteredChildren = item.children?.filter(
              (child) =>
                child.name !== "notifications" && child.name !== "alerts"
            );

            return { ...item, children: filteredChildren || [] };
          }
          // else if (userRole !== "Super-Admin" && userNature !== "cso") {
          //   // Remove 'charging_sessions' for specific roles
          //   const filteredChildren = item.children?.filter(
          //     (child) => child.name !== "charging_sessions"
          //   );

          //   return { ...item, children: filteredChildren || [] };
          // }

          // Default case, return the item unchanged
          return item;
        });
    },
  },

  methods: {
    filterItemByQuery(item, q) {
      if (item.children && item.children.length > 0) {
        const matchedChildren = item.children
          .map((c) => this.filterItemByQuery(c, q))
          .filter(Boolean);
        if (
          matchedChildren.length > 0 ||
          item.title.toLowerCase().includes(q)
        ) {
          return {
            ...item,
            children:
              matchedChildren.length > 0 ? matchedChildren : item.children,
          };
        }
        return null;
      }
      return item.title.toLowerCase().includes(q) ? item : null;
    },
    changeRoute(row, id) {
      // let params = {};
      // this.$store.dispatch("redirect/getQueryParams", id).then((res) => {
      //   params = { ...res }
      const data = this.$store.getters["redirect/getQueryFilters"];
      let params = {};
      params = { ...data(row.name) };
      if (params.date) {
        params.dateRange = params.date;
        delete params.date;
      }
      //
      const query = params;

      return { name: row.name, query };
      // this.$router.push(path.to).catch(() => {});
      // this.$router.push(PATH).catch(() => {});
      //});
    },
    checkActivePath(routeName) {
      if (this.activePath == routeName) {
        return "primary";
      } else if (
        this.activePath == "telematic_details" &&
        routeName == "vehicle_telematics"
      ) {
        return "primary";
      }
      // else if (
      //   this.activePath == "battery_diagnostics" &&
      //   routeName == "vehicle_telematics"
      // ) {
      //   return "primary";
      // }
      else if (this.activePath == "trip-listing" && routeName == "trips") {
        return "primary";
      } else if (this.activePath == "trip-detail" && routeName == "trips") {
        return "primary";
      } else if (
        this.activePath == "charge-session-list" &&
        routeName == "charge_session"
      ) {
        return "primary";
      } else if (
        this.activePath == "battery_diagnostics_list" &&
        routeName == "battery_diagnostics"
      ) {
        return "primary";
      } else if (
        this.activePath == "route-create" &&
        routeName == "route_listing"
      ) {
        return "primary";
      } else if (
        this.activePath == "route-edit" &&
        routeName == "route_listing"
      ) {
        return "primary";
      } else if (
        this.activePath == "job_route" &&
        routeName == "route_planning"
      ) {
        return "primary";
      } else {
        return "";
      }
    },
    mapItem(item) {
      return {
        ...item,
        children: item.children ? item.children.map(this.mapItem) : undefined,
        title: this.$t(item.title),
      };
    },
    changingMetaRoute(v) {
      if (v.name === "battery_analytics") {
        const url = `http://battery-analytics.orkofleet.com`;
        // window.open(url, "_blank");
        return url;
      } else if (v.name === "delivery") {
        const url = `https://delivery.orkofleet.com`;
        // window.open(url, "_blank");
        return url;
      } else if (v.name === "ev_rental") {
        const url = `https://evrental.orkofleet.com`;
        return url;
      }
    },

    // logout() {
    //   this.$store.dispatch("logout");
    //   this.$store.dispatch("checkAuth");
    // },
  },
};
</script>
<style scoped>
.v-list--nav {
  padding-left: 5px;
  padding-right: 5px;
}

.v-navigation-drawer--mini-variant .v-list-item__avatar:first-child {
  margin-right: 0px !important;
}
</style>
<style lang="sass" scoped>

$activeColor : var(--theme-light-color)
// $selectedTab: #0d4c45
$selectedTab : var(--drawer-active-color)

.nav-search-wrap
  .nav-search
    border-radius: 8px
    :deep .v-input__slot
      min-height: 34px !important
      padding: 0 8px !important
    :deep .v-text-field__slot input
      color: rgba(255,255,255,0.85) !important
      font-size: 0.8rem !important
      &::placeholder
        color: rgba(255,255,255,0.45) !important
    :deep .v-icon
      color: rgba(255,255,255,0.5) !important
      font-size: 18px !important
    :deep .v-input__prepend-inner
      margin-top: 7px !important

.brand-logo
  color: white !important
  justify-content: center
  align-items: center
  .title
    font-size: 19px !important
    font-weight: 600
    line-height: 20px
  .subTitle
    font-size: 11px
.drawer-open .v-list .v-list-group .v-list-item
  padding-left: 2rem
  color:  white !important
  i
    color: white !important

.v-list-item,.v-list-group
  .v-list-item__title
    color: white !important
  :deep .v-list-item__icon
    i
      color: white !important

  .v-list-group__header__append-icon
    background: red !important
// .v-list-group--active
//   color : white !important
:deep .v-list-group
  .v-list-group__items
    padding-left: 15px

.primary
  background: $selectedTab !important
  .v-list-item__icon, .v-list-item__title
    color: $activeColor  !important
    i
      color: $activeColor  !important
    span
      :deep svg
        g
          fill: $activeColor !important


.v-navigation-drawer__content .v-list
  padding: 4px 0 !important

#core-navigation-drawer
  height: 100% !important

@media only screen and (max-width: 960px)
  #core-navigation-drawer
    top: 3.5rem !important
</style>
